import { CmsApiThreeStepCtaBlockData } from 'modules/cms/api/types/CmsApiThreeStepCta';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpThreeStepCtaBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiThreeStepCtaBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.mainHeadline,
        subheadline: data.mainText,
        buttonText: data.buttonText,
        buttonUrl: data.buttonUrl,
        cards: [
          {
            image: data.stepOneImage,
            headline: data.stepOneHeadline,
            text: data.stepOneText,
            url: data.stepOneUrl,
          },
          {
            image: data.stepTwoImage,
            headline: data.stepTwoHeadline,
            text: data.stepTwoText,
            url: data.stepTwoUrl,
          },
          {
            image: data.stepThreeImage,
            headline: data.stepThreeHeadline,
            text: data.stepThreeText,
            url: data.stepThreeUrl,
          },
        ],
      }}
    />
  );
}
